import { createActions } from 'redux-actions';

export const {
  updateFilterFieldsVehicles,
  searchVehicles,
  countFiltersVehicles,
  resetFiltersVehicles,
} = createActions(
  'UPDATE_FILTER_FIELDS_VEHICLES',
  'SEARCH_VEHICLES',
  'COUNT_FILTERS_VEHICLES',
  'RESET_FILTERS_VEHICLES'
);
